import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#c9a87c',
      light: '#dbc4a0',
      dark: '#a88a5e',
    },
    secondary: {
      main: '#7b68ee',
      light: '#9f8ff3',
      dark: '#5a46d6',
    },
    background: {
      default: '#0a0a0f',
      paper: '#1a1a2e',
    },
    text: {
      primary: '#ede8e0',
      secondary: '#8a8a9a',
    },
    success: {
      main: '#4ade80',
    },
    warning: {
      main: '#f59e0b',
    },
    error: {
      main: '#ef4444',
    },
    divider: 'rgba(201,168,124,0.12)',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
      fontFamily: '"Inter", sans-serif',
    },
    h2: {
      fontWeight: 700,
      fontSize: '3rem',
      fontFamily: '"Inter", sans-serif',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2.5rem',
      fontFamily: '"Inter", sans-serif',
    },
    h4: {
      fontWeight: 600,
      fontSize: '2rem',
      fontFamily: '"Inter", sans-serif',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
      fontFamily: '"Inter", sans-serif',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
      fontFamily: '"Inter", sans-serif',
    },
    body1: {
      fontFamily: '"Inter", sans-serif',
    },
    body2: {
      fontFamily: '"Inter", sans-serif',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      fontFamily: '"Inter", sans-serif',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          padding: '10px 24px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          background: '#1a1a2e',
          border: '1px solid rgba(201,168,124,0.1)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: '#0a0a0f',
          borderBottom: '1px solid rgba(201,168,124,0.15)',
          boxShadow: 'none',
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          background: '#0a0a0f',
          borderTop: '1px solid rgba(201,168,124,0.15)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#0a0a0f',
          scrollbarColor: '#333 #0a0a0f',
        },
      },
    },
  },
});

export default theme;
